import { memo } from 'react'

import { WithChild } from 'utils'
import { MarkdownContent } from 'components/ui/Markdown/Markdown.styles'

const MdxWrapper = ({ children, ...rest }: WithChild): JSX.Element => (
  <MarkdownContent {...rest}>{children}</MarkdownContent>
)

export default memo(MdxWrapper)
